/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outside_AudienceInputs */

const en_outside_audience = /** @type {(inputs: Outside_AudienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For the systems around Nexxt`)
};

/**
* | output |
* | --- |
* | "For the systems around Nexxt" |
*
* @param {Outside_AudienceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const outside_audience = /** @type {((inputs?: Outside_AudienceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outside_AudienceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outside_audience(inputs)
});